import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useInView } from '../hooks/useInView';
import { images } from '../data/translations';

function DeepDiveBlock({ title, copy, image, reverse, index }) {
  const [ref, isInView] = useInView();

  return (
    <div
      ref={ref}
      data-testid={`fs-block-${index + 1}`}
      className={`flex flex-col ${reverse ? 'lg:flex-row-reverse' : 'lg:flex-row'} items-stretch transition-all duration-700 ${
        isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
      }`}
    >
      {/* Image */}
      <div className="lg:w-1/2 relative overflow-hidden min-h-[300px] lg:min-h-[420px]">
        <img
          src={image}
          alt={title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#121A30]/20 to-transparent" />
      </div>

      {/* Text */}
      <div className="lg:w-1/2 flex flex-col justify-center p-10 lg:p-16 bg-[#121A30]">
        <div className="w-10 h-0.5 bg-[#E71C25] mb-6" />
        <h3 className="text-2xl lg:text-3xl font-bold mb-5 tracking-tight leading-snug">{title}</h3>
        <p className="text-[#B0B0B0] leading-relaxed text-[15px]">{copy}</p>
      </div>
    </div>
  );
}

export default function FieldServicesDeepDive() {
  const { t } = useLanguage();
  const fsImages = [images.fs1, images.fs2, images.fs3];

  return (
    <section
      id="field-services"
      data-testid="field-services-section"
      className="bg-[#16213E]"
    >
      {/* Section header */}
      <div className="max-w-6xl mx-auto px-6 pt-20 pb-10">
        <div className="flex items-center gap-4 mb-3">
          <div className="w-12 h-1 bg-[#E71C25] rounded-full" />
          <span className="text-[#E71C25] text-xs font-bold tracking-[0.3em] uppercase">03</span>
        </div>
        <h2 className="text-3xl lg:text-5xl font-bold tracking-tight">
          {t.nav.fieldServices}
        </h2>
      </div>

      <div className="space-y-0">
        {t.fieldServices.blocks.map((block, i) => (
          <DeepDiveBlock
            key={i}
            index={i}
            title={block.title}
            copy={block.copy}
            image={fsImages[i]}
            reverse={i % 2 === 1}
          />
        ))}
      </div>
    </section>
  );
}
